import { useEffect } from 'react';

import { changeResolutionAction } from 'reduxState/screen/screenReducer';
import { detectResolution } from 'reduxState/screen/screenUtils';
import { useSelector, staticDispatch as dispatch } from 'reduxState/store';

// https://react-redux.js.org/next/api/hooks
function ScreenSizeDetector() {
  const resolutionIndex = useSelector(state => state.screen.resolutionIndex);
  const verticalResolutionIndex = useSelector(
    state => state.screen.verticalResolutionIndex
  );
  useEffect(() => {
    const resized = () => {
      const newResolution = detectResolution();
      if (
        resolutionIndex !== newResolution.resolutionIndex ||
        verticalResolutionIndex !== newResolution.verticalResolutionIndex
      ) {
        console.log(
          '[screenSizeDetector] Resized to index',
          newResolution.resolutionIndex
        );
        dispatch(changeResolutionAction(newResolution));
      }
    };
    window.addEventListener('resize', resized);
    return () => {
      window.removeEventListener('resize', resized);
    };
  }, [resolutionIndex, verticalResolutionIndex]);
  return null;
}

export default ScreenSizeDetector;
